var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fixed outline-none z-[9999] cursor-pointer",style:(_vm.style),attrs:{"tabindex":"0"},on:{"focusout":_vm.onFocusOut}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }